import axios from 'axios';
import koKR from './ko-KR';

/**
 * 메시지 리소스는 서버에서 내려받는 것(ko-KR.json)과, 프론트에서 정의(koKR)한 2가지를 합쳐 구성한다.
 */

const locale = {};

// 참고: 자바스크립트 특성 상 axios 호출은 한번만 실행됨
axios.get('/portal/api/res/string/ko-KR.json').then((res) => {
  Object.assign(locale, koKR);
  Object.assign(locale, res.data);
});

export default locale;
